<template>
  <!-- 商城管理 -->
  <div class="category">
    <el-form :inline="true" class="demo-form-inline" v-if="GLOBAL.kefu_flag">
      <el-form-item>
        <el-switch
          style="margin: 0 10px"
          v-model="shopEnable"
          active-text="开启商城"
          inactive-text="关闭商城"
          @change="handleShopEnable"
        >
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-switch
          style="margin: 0 10px"
          v-model="shopAffordableEnable"
          active-text="开启平价商城"
          inactive-text="关闭平价商城"
          @change="handleShopAffordableEnable"
        >
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-switch
          style="margin: 0 10px"
          v-model="nightDelivery"
          :active-value="0"
          :inactive-value="1"
          active-text="夜间发货"
          inactive-text="夜间不发货"
          @change="handleNightDelivery"
        >
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-switch
          style="margin: 0 10px"
          v-model="retrieveMark"
          :active-value="1"
          :inactive-value="0"
          active-text="可以取回"
          inactive-text="不可以取回"
          @change="handleRetrieveMark"
        >
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-switch
          v-model="activityShopEnable"
          :active-value="1"
          :inactive-value="0"
          active-text="开启活动商城"
          inactive-text="关闭活动商城"
          @change="handleActivityShopEnable"
        ></el-switch>
      </el-form-item>
      <el-form-item>
        <el-switch
          style="margin: 0 10px"
          v-model="forbidFetch"
          :active-value="1"
          :inactive-value="0"
          active-text="打开禁止所有取回"
          inactive-text="关闭禁止所有取回"
          @change="handleForbidFetch"
        >
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-switch
          style="margin: 0 10px"
          v-model="updatePrice"
          :active-value="1"
          :inactive-value="0"
          active-text="开启快速更新价格"
          inactive-text="关闭快速更新价格"
          @change="handleUpdatePrice"
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-button size="small" type="primary" @click="handleAdd"
          >添加商品
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-input v-model="query.id" placeholder="请输入商品id"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="query.name" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.shop_type" placeholder="商城类型">
          <el-option :value="undefined" v-if="GLOBAL.kefu_flag">全部</el-option>
          <el-option
            :value="1"
            label="csgo热门"
            v-if="GLOBAL.kefu_flag"
          ></el-option>
          <el-option :value="2" label="csgo平价"></el-option>
          <el-option
            :value="3"
            label="dota商城"
            v-if="GLOBAL.kefu_flag"
          ></el-option>
          <el-option
            :value="4"
            label="活动商城"
            v-if="GLOBAL.kefu_flag"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.state" placeholder="上下架状态">
          <el-option :value="undefined">全部</el-option>
          <el-option :value="1" label="上架"></el-option>
          <el-option :value="2" label="下架"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="pull-right" type="primary" @click="handleSearch"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item v-if="GLOBAL.kefu_flag">
        <el-select
          v-model="query.goods_type"
          placeholder="物品种类"
          @change="handleSearch"
        >
          <el-option :value="undefined">全部</el-option>
          <el-option :value="1" label="csgo"></el-option>
          <el-option :value="2" label="dota"></el-option>
          <el-option :value="3" label="活动商城"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="GLOBAL.kefu_flag">
        <el-cascader
          v-model="query.classificationValue"
          :options="classifications"
          :props="{ expandTrigger: 'hover' }"
          placeholder="物品分类"
          :show-all-levels="false"
          size="mini"
          @change="handleSearch"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item v-if="GLOBAL.kefu_flag">
        <el-button size="small" type="primary" @click="updateAllIG"
          >更新IG价格与数量
        </el-button>
      </el-form-item>
      <el-form-item v-if="GLOBAL.kefu_flag">
        <el-input
          style="width: 150px"
          v-model="priceRange.min_price"
          placeholder="价格区间(低)"
        ></el-input>
        -
        <el-input
          style="width: 150px"
          v-model="priceRange.max_price"
          placeholder="价格区间(高)"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="GLOBAL.kefu_flag">
        <el-button type="primary" @click="shelvesALL">一键上架</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">
          <a :href="robotLink" target="_blank" rel="noopener noreferrer">
            平价商城同步库存
          </a>
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="shelvesRobot">
          下架机器人饰品
        </el-button>
      </el-form-item>
    </el-form>

    <div>
      <!-- 商城商品列表 -->
      <el-table :data="dataList" v-loading="loading" @sort-change="handleSort">
        <el-table-column prop="id" label="商品ID"></el-table-column>
        <el-table-column prop="name" label="商品名称"></el-table-column>
        <el-table-column label="图片" width="100px">
          <template slot-scope="{ row }">
            <img width="80" class="table-image" :src="row.image" alt />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>
        <el-table-column
          prop="guarantee_price"
          label="保底价格"
        ></el-table-column>
        <el-table-column prop="appearance" label="外观">
          <template slot-scope="{ row }">
            <span v-if="row.appearance === 1">崭新出厂</span>
            <span v-if="row.appearance === 2">略有磨损</span>
            <span v-if="row.appearance === 3">久经沙场</span>
            <span v-if="row.appearance === 4">破损不堪</span>
            <span v-if="row.appearance === 5">战痕累累</span>
            <span v-if="row.appearance === 6">无涂装</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="暗金">
          <template slot-scope="{ row }">
            <span v-if="row.type === 1">普通</span>
            <span v-if="row.type === 2">StatTrak™ </span>
            <span v-if="row.type === 3">纪念品</span>
            <span v-if="row.type === 4">★</span>
            <span v-if="row.type === 5">★StatTrak™</span>
          </template>
        </el-table-column>
        <el-table-column prop="quality" label="品质">
          <template slot-scope="{ row }">
            <span v-if="row.quality === 1">消费级</span>
            <span v-if="row.quality === 2">军规级 </span>
            <span v-if="row.quality === 3">工业级</span>
            <span v-if="row.quality === 4">受限</span>
            <span v-if="row.quality === 5">保密</span>
            <span v-if="row.quality === 6">隐秘</span>
            <span v-if="row.quality === 7">普通级</span>
            <span v-if="row.quality === 8">高级</span>
            <span v-if="row.quality === 9">非凡</span>
            <span v-if="row.quality === 10">奇异</span>
            <span v-if="row.quality === 11">卓越</span>
            <span v-if="row.quality === 12">违禁</span>
            <span v-if="row.quality === 13">探员-高级</span>
            <span v-if="row.quality === 14">探员-卓越</span>
            <span v-if="row.quality === 15">探员-非凡</span>
            <span v-if="row.quality === 16">探员-大师</span>
          </template>
        </el-table-column>
        <el-table-column prop="rarity" label="稀有度">
          <template slot-scope="{ row }">
            {{ getDotararity(row.rarity) }}
          </template>
        </el-table-column>
        <el-table-column prop="shop_type" label="上架商城">
          <template slot-scope="{ row }">
            <span v-if="row.shop_type === 1">csgo热门</span>
            <span v-if="row.shop_type === 2">csgo平价</span>
            <span v-if="row.shop_type === 3">dota商城</span>
          </template>
        </el-table-column>
        <el-table-column prop="prize_form" label="商品来源">
          <template slot-scope="{ row }">
            <span v-if="row.prize_form === 1">ZBT商品</span>
            <span v-if="row.prize_form === 2">自有商品</span>
            <span v-if="row.prize_form === 3">机器人商品</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="num"
          label="库存"
          sortable="custom"
        ></el-table-column>
        <el-table-column label="IG手动">
          <template slot-scope="{ row }">
            <span>
              {{ (row.ig_prize && row.ig_prize.manual_min_price) || 0 }}({{
                (row.ig_prize && row.ig_prize.manual_sale_count) || 0
              }})
            </span>
          </template>
        </el-table-column>
        <el-table-column label="IG自动">
          <template slot-scope="{ row }">
            <span>
              {{ (row.ig_prize && row.ig_prize.auto_min_price) || 0 }}({{
                (row.ig_prize && row.ig_prize.auto_sale_count) || 0
              }})
            </span>
          </template>
        </el-table-column>
        <el-table-column label="IG在售最低价">
          <template slot-scope="{ row }">
            <span> {{ row.ig_prize && row.ig_avg_price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="自动发货在售最低价">
          <template slot-scope="{ row }">
            <span>
              {{ row.auto_deliver_price }}({{
                row.auto_deliver_quantity
              }})</span
            >
          </template>
        </el-table-column>
        <el-table-column label="人工发货在售最低价">
          <template slot-scope="{ row }">
            <span>
              {{ row.manual_deliver_price }}({{ row.manual_quantity }})</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="state" label="zbt发货方式">
          <template slot-scope="{ row }" v-if="row.prize_form == 1">
            <el-button
              type="success"
              v-if="row.delivery_way == 1"
              @click="(val) => changeDelivery(row, 2)"
              >人工
            </el-button>
            <el-button
              type="info"
              v-else
              @click="(val) => changeDelivery(row, 1)"
              >自动</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" width="120px" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="success"
              plain
              v-if="row.state == 1"
              @click="(val) => changeConfig(row, 2)"
            >
              {{ row.prize_form == 3 ? "上架更新" : "上架" }}</el-button
            >
            <el-button
              type="info"
              plain
              v-else
              @click="(val) => changeConfig(row, 1)"
            >
              {{ row.prize_form == 3 ? "下架不更新" : "下架" }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px" fixed="right">
          <template slot-scope="{ row }">
            <el-row class="operation-row">
              <el-button type="primary" plain @click="handleEdit(row)"
                >编辑
              </el-button>
              <el-button
                type="warning"
                @click="handleHistory(row)"
                style="margin-top: 10px"
                >记录
              </el-button>
            </el-row>
            <el-row class="operation-row">
              <el-dropdown style="margin-left: 10px" @command="bannedEvent">
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ rowInfo: row, command: 1 }"
                    >IG</el-dropdown-item
                  >
                  <el-dropdown-item :command="{ rowInfo: row, command: 2 }"
                    >更新IG价格</el-dropdown-item
                  >
                  <el-dropdown-item :command="{ rowInfo: row, command: 3 }"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1"
        :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 添加商品 -->
    <el-dialog
      :visible.sync="visible"
      :title="isEdit ? '编辑商品' : '添加商品'"
      width="400px"
    >
      <el-form :model="formData" label-width="100px" :rules="rules" ref="form">
        <el-form-item prop="prize_id" label="商品(自有)">
          <div v-if="selectedPrize2" class="prize-item">
            <img :src="selectedPrize2.image" @click="openGoodsDialog(2)" />
            <p>
              <span>{{ selectedPrize2.name }}</span>
            </p>
            <p>
              <span>{{ selectedPrize2.second_name }}</span>
            </p>
            <p>
              <span></span>
              <span class="price">${{ selectedPrize2.price }}</span>
            </p>
          </div>
          <div v-else class="add-prize" @click="openGoodsDialog(2)">
            <i class="el-icon-plus"></i>
            <p>选择奖品</p>
          </div>
        </el-form-item>
        <!-- <el-form-item prop="prize_id" label="商品(扎比特)" v-if="GLOBAL.kefu_flag">
          <div v-if="selectedPrize1" class="prize-item">
            <img :src="selectedPrize1.image" @click="openGoodsDialog(1)" />
            <p>
              <span>{{ selectedPrize1.name }}</span>
            </p>
            <p>
              <span>{{ selectedPrize1.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(selectedPrize1.rank)};`">{{
                  getRank(selectedPrize1.rank)
              }}</span>
              <span class="price">${{ selectedPrize1.price }}</span>
            </p>
          </div>
          <div v-else class="add-prize" @click="openGoodsDialog(1)">
            <i class="el-icon-plus"></i>
            <p>选择奖品</p>
          </div>
        </el-form-item> -->
        <el-form-item prop="prize_id" label="商品(IG)" v-if="GLOBAL.kefu_flag">
          <AddIGGoods
            :prizeInfo="selectedPrize1"
            @selectedData="getSelectedData"
          ></AddIGGoods>
        </el-form-item>
        <el-form-item prop="prize_id" label="商品(机器人)">
          <div v-if="selectedPrize3" class="prize-item">
            <img :src="selectedPrize3.image" @click="openGoodsDialog(3)" />
            <p>
              <span>{{ selectedPrize3.name }}</span>
            </p>
            <p>
              <span>{{ selectedPrize3.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(selectedPrize3.rank)};`">{{
                getRank(selectedPrize3.rank)
              }}</span>
              <span class="price">${{ selectedPrize3.price }}</span>
            </p>
          </div>
          <div v-else class="add-prize" @click="openGoodsDialog(3)">
            <i class="el-icon-plus"></i>
            <p>选择奖品</p>
          </div>
        </el-form-item>
        <el-form-item prop="price" label="价格">
          <el-input v-model="formData.price"></el-input>
        </el-form-item>
        <el-form-item prop="guarantee_price" label="保底价格">
          <el-input v-model="formData.guarantee_price"></el-input>
        </el-form-item>
        <el-form-item label="ig最低金额" v-if="prizeType === 3">
          <span>{{ ig_min_price }}</span>
          <span
            style="cursor: pointer; color: blue; margin-left: 10px"
            v-if="isEdit"
            @click="refreshPrice"
            >刷新</span
          >
        </el-form-item>
        <el-form-item prop="num" label="数量">
          <el-input v-model="formData.num"></el-input>
        </el-form-item>
        <el-form-item prop="one_buy_num" label="单人购买数量">
          <el-input v-model="formData.one_buy_num"></el-input>
        </el-form-item>
        <el-form-item prop="sort" label="排序">
          <el-input v-model="formData.sort"></el-input>
        </el-form-item>
        <el-form-item prop="goods_type" label="物品类型">
          <el-select v-model="formData.goods_type" placeholder="物品类型">
            <el-option :value="1" label="csgo物品"></el-option>
            <el-option :value="2" label="dota物品"></el-option>
            <el-option :value="3" label="活动商城物品"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="shop_type" label="商城类型">
          <el-select v-model="formData.shop_type" placeholder="商城类型">
            <el-option :value="1" label="csgo热门"></el-option>
            <el-option :value="2" label="csgo平价"></el-option>
            <el-option :value="3" label="dota商城"></el-option>
            <el-option :value="4" label="活动商城"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="is_show"
          label="新用户物品"
          v-if="formData.shop_type === 2"
        >
          <el-select
            v-model="formData.is_show"
            placeholder="请选择是否是新用户物品"
          >
            <el-option :value="0" label="是"></el-option>
            <el-option :value="1" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="appearance"
          label="外观"
          v-if="formData.shop_type != 3"
        >
          <el-select v-model="formData.appearance">
            <el-option
              v-for="item in shopAppearance"
              :key="item.type"
              :value="item.type"
              :label="item.text || '无'"
            >
              <span>{{ item.text || "无" }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="type" label="暗金" v-if="formData.shop_type != 3">
          <el-select v-model="formData.type">
            <el-option
              v-for="item in shopType"
              :key="item.type"
              :value="item.type"
              :label="item.text"
            >
              <span>{{ item.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="quality"
          label="品质"
          v-if="formData.shop_type != 3"
        >
          <el-select v-model="formData.quality">
            <el-option
              v-for="item in shopQuality"
              :key="item.val"
              :value="item.val"
              :label="item.text"
            >
              <span>{{ item.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          prop="classify"
          label="种类"
          v-if="formData.shop_type != 3"
        >
          <el-cascader
            v-model="formData.classify"
            :options="classifications"
            :props="{ expandTrigger: 'hover' }"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item
          prop="rarity"
          label="稀有度"
          v-if="formData.shop_type === 3"
        >
          <el-select v-model="formData.rarity">
            <el-option
              v-for="item in rarityList"
              :key="item.val"
              :value="item.val"
              :label="item.text"
            >
              <span>{{ item.text }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          @click="submit(1)"
          :loading="buttonLoading"
          >保存直接上架</el-button
        >
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submit"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 要添加的奖品列表 -->
    <el-dialog
      :visible.sync="visiblePrize"
      title="奖品列表"
      :close-on-click-modal="false"
      width="930px"
    >
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            placeholder="奖品名称搜索"
            v-model="queryPrize.prizeName"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="prizeSearch(1)">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="queryPrize.type"
            placeholder="物品种类"
            @change="prizeSearch(1)"
          >
            <el-option :value="1" label="csgo"></el-option>
            <el-option :value="2" label="dota"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="prize-list-wrap" v-loading="loadingPrize">
        <ul class="prize-list">
          <li class="prize-item" v-for="item in prizeList" :key="item.id">
            <i
              class="el-icon-plus"
              title="添加"
              @click="handleAddPrize(item)"
            ></i>
            <img :src="item.image" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
            <p>
              <span v-if="queryPrize.type === 1">{{ item.second_name }}</span>
              <span v-else>{{ getDotararity(item.rarity) }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(item.rank)};`">{{
                getRank(item.rank)
              }}</span>
              <span class="price">${{ item.price }}</span>
            </p>
            <p style="text-align: center">
              数量：{{ item.number - item.sold_number }}
            </p>
          </li>
        </ul>
      </div>
      <el-pagination
        background
        :page-size="prizeListMeta.per_page || 15"
        :total="prizeListMeta.total || 0"
        :current-page="queryPrize.page"
        @current-change="handlePrizePageChange"
        v-if="prizeListMeta && prizeListMeta.total > prizeListMeta.per_page"
      ></el-pagination>
    </el-dialog>

    <!-- 日志记录 -->
    <el-dialog
      :visible.sync="historyVisible"
      title="价格记录"
      width="850px"
      @close="historyVisible = false"
      center
    >
      <el-table :data="historyList" v-loading="dialogLoading">
        <el-table-column
          prop="before_price"
          label="更新前价格"
        ></el-table-column>
        <el-table-column prop="price" label="更新后价格"> </el-table-column>
        <el-table-column prop="ig_price" label="IG价格" width="350px">
        </el-table-column>
        <el-table-column prop="avg_price" label="平均价格"></el-table-column>
        <el-table-column prop="updated_at" label="时间"></el-table-column>
      </el-table>
      <el-pagination
        background
        :total="logDataMeta ? logDataMeta.total : 0"
        :current-page="logDataMeta ? logDataMeta.current_page : 1"
        :page-size="logDataMeta ? logDataMeta.per_page : 15"
        @current-change="handlLogPageChange"
      ></el-pagination>
    </el-dialog>

    <!-- IG物品查询 -->
    <IgGoods
      :visible="igGoodsVisible"
      v-model="getPrizeInfo"
      :typeNum="2"
      @close="igGoodsVisible = false"
    ></IgGoods>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { delApiData, getData, getApiData, postApiData, patchApiData } from '@/http'
import classification from '@/assets/js/classification'//csgo商品种类
import shopAppearance from '@/assets/js/shopAppearance'//csgo外观
import shopType from '@/assets/js/shopType'//csgo暗金
import shopQuality from '@/assets/js/shopQuality'//csgo品质
import rarityList from '@/assets/js/rarityList'//dota稀有度
import IgGoods from '@/components/thirdPartyGoods/IgGoods'//一个物品查看
import AddIGGoods from '@/components/goods/AddIGGoods'//ig物品添加
export default {
  components: {
    IgGoods,
    AddIGGoods
  },
  data() {
    return {
      historyVisible: false,//记录弹窗显示标志
      igGoodsVisible: false,//IG商品弹窗
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载动画
      lock: false,//更新IG价格和数量的锁
      deliveryWay: false,//默认人工发货
      shopEnable: undefined,//商城开关标志
      shopAffordableEnable: undefined,//平价商城开关标志
      activityShopEnable: 0,//活动开关状态 0是关闭，1是打开
      classifications: classification,//csgo种类
      shopAppearance: shopAppearance,//csgo外观
      shopType: shopType,//csgo暗金
      shopQuality: shopQuality,//csgo品质
      rarityList: rarityList,//dota稀有度
      nightDelivery: 0,//0代表夜间不发货、1代表夜间发货
      retrieveMark: 1,//0代表不能取回、1代表可以取回
      forbidFetch: 1,//0代表关闭禁止所有取回、1代表打开禁止所有取回
      updatePrice: 0,//0代表关闭快速更新价格、1代表打开快速更新价格
      dataList: undefined,
      dataMeta: {},
      prizes: [],
      prizeShow: false,
      prizeData: [],
      prizeDataLoading: false,
      formData: {
        name: '',
        price: undefined,
        guarantee_price: undefined,
        num: undefined,
        type: '',
        one_buy_num: 0,
        appearance: '',
        quality: '',
        is_show: 1,
        goods_type: '',
        shop_type: '',
        rarity: undefined,
        image: '',
        sort: 0
      },
      priceRange: {
        min_price: '',
        max_price: ''
      },
      rules: {
        price: [{ required: true, message: '请输入盒子的价格' }],
        guarantee_price: [{ required: true, message: '请输入保底价格' }],
        goods_type: [{ required: true, message: '请选择物品类型' }],
        shop_type: [{ required: true, message: '请选择商城类型' }],
        appearance: [{ required: true, message: '请输入商品外观' }],
        quality: [{ required: true, message: '请输入商品品质' }],
        type: [{ required: true, message: '请输入商品类别' }]
      },
      query: {
        page: 1,
        id: undefined,
        name: undefined,
        shop_type: undefined,
        state: undefined,
        goods_type: undefined,
        classificationValue: undefined,//物品分类
        order: '',
        order_type: '',
      },
      editInfo: undefined,
      loading: false,
      visible: false,
      isEdit: false,
      loadingPrize: false,
      prizeList: undefined,
      prizeListMeta: {},
      queryPrize: {//选择奖品-查询奖品
        page: 1,//页数
        prizeName: '',//奖品列表搜索奖品的名字
        type: 1,//类型,1是csgo 2是dota
      },
      visiblePrize: false,
      // selectedPrize: undefined,//选择的商品的信息
      selectedPrize1: undefined,//选择的 扎比特 商品的信息
      selectedPrize2: undefined,//选择的 自有 商品的信息
      selectedPrize3: undefined,//选择的 机器人 商品的信息
      zbtPrize: undefined,
      zbtPrizeMeta: {},
      originPrize: undefined,
      originPrizeMeta: {},
      prizeEditRow: '',
      prizeType: 0,//选择的物品 1扎比特或ig物品 2自有 3机器人
      zbtPrizeList: undefined,//zbt物品列表
      robotPrizeList: undefined,//机器人物品列表
      robotPrizeMeta: {},
      historyList: undefined,//记录日志信息列表
      queryLog: {//查询记录信息
        page: 1
      },
      logId: undefined,//要查询的记录的商品id
      logDataMeta: undefined,//记录日志信息分页
      getPrizeInfo: {},//第三方弹窗中要用的信息
      ig_min_price: '',//添加物品时显示ig最低价格
      robotLink: 'http://hzsteam.csgotopbox.com/shop_sync',//平价商城同步库存切换状态
    }
  },
  watch: {
    'query.name'(val) {
      //转化格式不同的空格，防止搜索无法匹配
      this.query.name = val.replace(/\s+/g, " ")
    },
    zbtPrizeList(val) {
      //监听zbt物品列表，变化时重新赋值数据列表
      if (this.prizeType === 1) {
        this.getPrizeList(this.prizeType)
      }
    },
    originPrize(val) {
      //监听自有物品列表，变化时重新赋值数据列表
      if (this.prizeType === 2) {
        this.getPrizeList(this.prizeType)
      }
    },
    robotPrizeList(val) {
      //监听机器人物品列表，变化时重新赋值数据列表
      if (this.prizeType === 3) {
        this.getPrizeList(this.prizeType)
      }
    },
  },
  // computed: {
  // 	...mapState({
  // 		dataList: state => state.data.caseList.data,
  // 		dataMeta: state => state.data.caseList.meta,
  // 		categories: state => state.data.categories
  // 	}),
  // 	...mapGetters(['boxGroupList']),
  // 	headers() {
  // 		return {
  // 			Authorization: 'Bearer ' + getCookie('access_token')
  // 		}
  // 	},
  // 	action() {
  // 		return `${server}file`
  // 	}
  // },
  methods: {
    ...mapActions(['getCaseList', 'getCategories', 'getBoxGroupList']),
    //平价商城同步库存链接，走的那套逻辑
    getRobotStatus() {
      getApiData('robot_link')
        .then(res => {
          if (res) {
            this.robotLink = res
          }
        }).finally(() => {
        })
    },
    //下架机器人饰品
    shelvesRobot() {
      this.$confirm('确定要下架机器人饰品吗？', {
        type: 'warning'
      }).then(res => {
        patchApiData(`shop_robot_lower_shelf`)
          .then(res => {
            if (res.code) {
              this.$message.success(res.err)
            } else {
              this.$message.error(res.err)
            }
          })
          .finally(() => {
          })
      })
    },
    //更多操作
    bannedEvent(commandInfo) {
      if (commandInfo.command === 1) {
        //IG
        this.searchIgGoods(commandInfo.rowInfo)
      }
      if (commandInfo.command === 2) {
        //更新IG价格
        this.updateIGPrice(commandInfo.rowInfo)
      }
      if (commandInfo.command === 3) {
        //删除
        this.handleDelete(commandInfo.rowInfo.id)
      }
    },
    refreshPrice() {
      //编辑机器人商品时，刷新ig最低价格
      let params = {
        id: this.formData.id
      }
      getApiData(`shop_robot_ig_price`, params)
        .then(res => {
          this.ig_min_price = res
        })
        .finally(() => {
        })
    },
    getRank(rank) {
      return ''
      // for (let item of this.ranks) {
      // 	if (item.level === rank) {
      // 		return item.text
      // 	}
      // }
    },
    getRankColor(rank) {
      return '#000'
      // for (let item of this.ranks) {
      // 	if (item.level === rank) {
      // 		return item.color
      // 	}
      // }
    },
    handleSort(column) {
      this.query.order = column.prop
      this.query.order_type = column.order === 'ascending' ? 'asc' : 'desc'
      this.query.page = 1
      this.getData()
    },
    shelvesALL() {
      //一键上架指定价格范围内的物品
      let params = this.priceRange
      patchApiData(`shopPrizeBatchShelves`, params)
        .then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.getData()
            this.priceRange = {
              min_price: '',
              max_price: ''
            }
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    handleDeliveryWay() {
      patchApiData(`zbt_delivery_way`, {
        deliveryWay: this.deliveryWay
      })
        .then(res => {
          this.$message.success(res.err)
          this.getData()
        })
        .catch((err) => {
          this.deliveryWay = !this.deliveryWay
        })
    },
    getShopEnable() {
      //获取商城开关状态
      getApiData(`shop_enable`)
        .then(res => {
          this.shopEnable = res.data
        })
        .finally(() => {
        })
    },
    handleShopEnable() {
      //控制商城开关
      this.loading = true
      patchApiData(`shop_enable`, {
        shopEnable: this.shopEnable
      })
        .then(res => {
          this.$message.success("操作成功！")
          this.getData()
        })
        .finally(() => {
          this.loading = false
        })
    },
    getActivityShopEnable() {
      getApiData('active_shop')
        .then(res => {
          if (res) {
            res.data ? this.activityShopEnable = 1 : this.activityShopEnable = 0
          }
        })
    },
    handleActivityShopEnable() {
      //关闭/打开活动商城
      let params = { "black": this.activityShopEnable ? 1 : 0 }
      patchApiData('active_shop', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getActivityShopEnable()//刷新
        }).catch(err => {
          //关闭/打开失败，还原标志
          this.activityShopEnable = this.activityShopEnable ? 0 : 1
        })
    },


    getShopAffordableEnable() {
      //获取商城开关状态
      getApiData(`parity_shop_enable`)
        .then(res => {
          this.shopAffordableEnable = res.data
        })
        .finally(() => {
        })
    },
    handleShopAffordableEnable() {
      //控制平价商城开关
      patchApiData(`parity_shop_enable`, {
        black: this.shopAffordableEnable
      })
        .then(res => {
          this.$message.success("操作成功！")
        })
    },
    changeConfig(row, state) {
      patchApiData('shop_status/' + row.id, {
        state: state
      })
        .then(
          res => {
            if (res.err) {
              this.$message.error(res.err)
            } else {
              this.$message.success('修改设置成功')
            }
            this.getData()
          }
        )
        .finally(() => {
          // this.loading = false
        })
    },
    changeDelivery(row, state) {
      this.loading = true
      patchApiData('shop_zbt_delivery/' + row.id, {
        state: state
      })
        .then(
          res => {
            if (res.err) {
              this.$message.success(res.err)
            }
            this.getData()
          }
        )
        .finally(() => {
          this.loading = false
        })
    },
    prizeSearch(parameter) {
      if (parameter === 1) {
        //当点击查询搜索时，还原下标页为1
        this.queryPrize.page = 1
      }
      if (this.prizeType === 1) {
        this.getZbtPrize()
      } else if (this.prizeType === 2) {
        this.getPrize()
      } else {
        this.getRobotPrize()
      }
    },
    //打开选择物品弹窗
    openGoodsDialog(num) {
      this.visiblePrize = true//打开弹窗
      this.getPrizeList(num)
    },
    //赋值对应的物品列表
    getPrizeList(listType) {
      if (listType === 1) {//扎比特
        this.prizeList = this.zbtPrizeList
        this.prizeListMeta = this.zbtPrizeMeta
        this.prizeType = listType
      } else if (listType === 2) {//自有
        this.prizeList = this.originPrize
        this.prizeListMeta = this.originPrizeMeta
        this.prizeType = listType
      } else {//机器人
        this.prizeList = this.robotPrizeList
        this.prizeListMeta = this.robotPrizeMeta
        this.prizeType = listType
      }
    },
    //获取到IG物品后的反参数据
    getSelectedData(data) {
      //赋值选择的物品信息
      this.prizeType = 1 //ig与zbt同状态
      this.handleAddPrize(data)
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    getData() {
      //获取列表数据
      this.loading = true
      if (!this.GLOBAL.kefu_flag) {
        //客服后台只显示平价商城物品
        this.query.shop_type = 2
      }
      // 组合分类
      if (this.query.classificationValue && this.query.classificationValue[0] != 0) {
        if (this.query.classificationValue[1]) {
          this.query.class = this.query.classificationValue[1]
        } else {
          this.query.class = this.query.classificationValue[0]
        }
      } else {
        this.query.class = undefined
      }

      getApiData(`shop`, this.query)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = {
            current_page: res.current_page,
            per_page: res.per_page,
            total: res.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDeliveryWay() {
      getApiData(`zbt_delivery_way`)
        .then(res => {
          this.deliveryWay = res.data
        })
        .finally(() => {
        })
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    getNightDelivery() {
      //获取夜间发货状态的接口
      getApiData(`shop_defend_enable`)
        .then(res => {
          if (res && res.data) {
            this.nightDelivery = 1
          } else {
            this.nightDelivery = 0
          }
        })
    },
    handleNightDelivery(val) {
      // 开启或关闭夜间发货
      let params = {
        black: val
      }
      patchApiData('shop_defend_enable', params).then(res => {
        if (res) {
          this.$message.success("操作成功!")
        }
      }).catch(err => {
        this.nightDelivery = (val === 1) ? 0 : 1
      })
    },
    getRetrieveMark() {
      //获取取回状态的接口
      getApiData(`get_back_config`)
        .then(res => {
          if (res && res.data) {
            this.retrieveMark = 1
          } else {
            this.retrieveMark = 0
          }
        })
    },
    handleRetrieveMark(val) {
      // 开启或关闭背包取回
      let params = {
        black: val
      }
      patchApiData('get_back_config', params).then(res => {
        if (res) {
          this.$message.success("操作成功!")
        }
      }).catch(err => {
        this.retrieveMark = (val === 1) ? 0 : 1
      })
    },
    getForbidFetch() {
      //获取取回状态的接口
      getApiData(`user_retrieval_enable`)
        .then(res => {
          if (res && res.data) {
            this.forbidFetch = 1
          } else {
            this.forbidFetch = 0
          }
        })
    },
    handleForbidFetch(val) {
      // 开启或关闭背包取回
      let params = {
        black: val
      }
      patchApiData('user_retrieval_enable', params).then(res => {
        if (res) {
          this.$message.success("操作成功!")
        }
      }).catch(err => {
        this.forbidFetch = (val === 1) ? 0 : 1
      })
    },
    getUpdatePrice() {
      //获取快速更新价格开关状态
      getApiData(`shop_price_update_time_enable`)
        .then(res => {
          if (res && res.data) {
            this.updatePrice = 1
          } else {
            this.updatePrice = 0
          }
        })
    },
    handleUpdatePrice(val) {
      // 开启或关闭快速更新价格开关
      let params = {
        black: val
      }
      patchApiData('shop_price_update_time_enable', params).then(res => {
        if (res) {
          this.$message.success("操作成功!")
        }
      }).catch(err => {
        this.updatePrice = (val === 1) ? 0 : 1
      })
    },
    updateAllIG() {
      //一键更新全部的IG价格和数量
      this.$prompt('请输入密码', '确认更新？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /lijiulong123/,
        inputErrorMessage: '密码不正确'
      }).then(({ value }) => {
        if (this.lock) {
          this.$message.warning("请求正在进行中，请勿频繁点击！")
          return
        }
        this.lock = true
        getApiData(`ig/get_price_num`)
          .then(res => {
            this.$message.success("数据已全部更新！")
            this.getData()//刷新数据
          }).catch(() => {
            //报错也要去刷新数据
            this.$message.success("可能已有部分数据刷新，注意查看！")
            this.getData()//刷新数据
          }).finally(() => {
            this.lock = false
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleAdd() {
      this.formData = {}
      // this.selectedPrize = undefined
      this.selectedPrize1 = undefined
      this.selectedPrize2 = undefined
      this.selectedPrize3 = undefined
      this.isEdit = false
      this.editInfo = undefined
      this.visible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editInfo = JSON.parse(JSON.stringify(row))
      // this.selectedPrize = JSON.parse(JSON.stringify(row))

      //先置空再赋值
      this.selectedPrize1 = undefined
      this.selectedPrize2 = undefined
      this.selectedPrize3 = undefined
      switch (row.prize_form) {
        case 1:
          //扎比特或ig物品
          this.selectedPrize1 = JSON.parse(JSON.stringify(row)); break;
        case 2:
          //自有物品
          this.selectedPrize2 = JSON.parse(JSON.stringify(row)); break;
        case 3:
          //机器人物品
          this.selectedPrize3 = JSON.parse(JSON.stringify(row)); break;
      }
      this.formData = JSON.parse(JSON.stringify(row))
      this.formData.classify = [row.big_class, row.class]
      this.formData.class = row.class
      this.formData.big_class = row.big_class
      this.visible = true
      this.prizeType = row.prize_form
    },
    handleDetail(row) {
      // this.$router.push(`/case/${row.id}?cid=${row.category_id}`)
      let routeData = this.$router.resolve({ path: `/case/${row.id}?cid=${row.category_id}` })
      window.open(routeData.href, '_blank')
    },
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`shop/${id}`).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    handleHistory(rowInfo) {
      //日志记录
      this.historyVisible = true
      this.logId = rowInfo.id
      this.getHistory()
    },
    getHistory() {
      //拿取记录信息列表
      this.dialogLoading = true
      getApiData(`shop_price/${this.logId}`, this.queryLog)
        .then(res => {
          if (res && res.data) {
            this.historyList = res.data
            this.logDataMeta = res
          }
        })
        .finally(() => {
          this.dialogLoading = false
        })
    },
    handlLogPageChange(val) {
      //记录信息分页
      this.queryLog.page = val
      this.getHistory()//刷新记录数据
    },
    searchIgGoods(rowInfo) {
      //查询ig商品
      this.igGoodsVisible = true
      this.goodsName = rowInfo.name
      this.getPrizeInfo = {
        prizeName: rowInfo.name
      }
    },
    updateIGPrice(rowInfo) {
      //更新ig价格
      this.buttonLoading = true
      getApiData(`shop_ig_price/${rowInfo.id}`)
        .then(res => {
          this.getData()
        })

    },
    submit(num) {
      this.$refs['form'].validate(valid => {
        if (valid) {
          // 数据处理
          this.formData.big_class = this.formData.classify[0]
          this.formData.class = this.formData.classify[1]
          this.formData.prize_form = this.prizeType


          //拼接指定的物品的名字和选择的外观的名字
          for (let item of this.shopAppearance) {
            if (item.type === this.formData.appearance) {
              //先判断是否已存在磨损度。存在则先删除磨损度，再拼接
              if (this.formData.name.indexOf('(') != -1) {
                let num = this.formData.name.indexOf('(')
                this.formData.name = this.formData.name.substring(0, num)
                if (item.text) {
                  this.formData.name = this.formData.name.replace(/(^\s*)|(\s*$)/g, "") + ' (' + item.text + ')'
                } else {
                  this.formData.name = this.formData.name
                }
              } else {
                if (item.text) {
                  this.formData.name = this.formData.name.replace(/(^\s*)|(\s*$)/g, "") + ' (' + item.text + ')'
                } else {
                  this.formData.name = this.formData.name
                }
              }
            }
          }

          if (num === 1) {
            //保存直接上架按钮
            this.formData.state = 1
          }

          this.buttonLoading = true
          if (!this.editInfo) {
            postApiData('shop', {
              ...this.formData
            })
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                this.$message.success(res.err)
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          } else {
            const params = { ...this.formData }
            patchApiData(`shop/${this.editInfo.id}`, {
              ...params
            })
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                this.$message.success(res.err)
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          }
        }
      })
    },
    getPrize() {
      //获取自有物品列表
      this.loadingPrize = true
      getData(`prize`, { category_id: this.query.category_id, page: this.queryPrize.page, name: this.queryPrize.prizeName, type: this.queryPrize.type })
        .then(res => {
          this.originPrize = res.data
          this.originPrizeMeta = res.meta
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    getZbtPrize() {
      //获取zbt物品列表
      this.loadingPrize = true
      getApiData(`zbtPrize`, { page: this.queryPrize.page, name: this.queryPrize.prizeName, type: this.queryPrize.type })
        .then(res => {
          this.zbtPrizeList = res.data
          this.zbtPrizeMeta = res.meta
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    getRobotPrize() {
      //获取机器人物品列表
      this.loadingPrize = true
      getApiData(`robotPrize`, { page: this.queryPrize.page, name: this.queryPrize.prizeName, type: this.queryPrize.type })
        .then(res => {
          this.robotPrizeList = res.data
          this.robotPrizeMeta = res.meta
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    handlePrizePageChange(page) {
      this.queryPrize.page = page
      if (this.prizeType === 1) {
        this.getZbtPrize()
      } else if (this.prizeType === 2) {
        this.getPrize()
      } else {
        this.getRobotPrize()
      }
      this.getPrizeList(this.prizeType)
    },
    handleAddPrize(row) {
      this.formData = {
        name: '',
        price: undefined,
        guarantee_price: undefined,
        num: undefined,
        type: '',
        one_buy_num: 0,
        appearance: '',
        quality: '',
        is_show: 1,
        goods_type: '',
        shop_type: '',
        image: '',
        sort: 0,
        classify: '',
        rarity: undefined,
      }
      this.ig_min_price = row.ig_min_price//保存ig最低价
      this.formData.name = row.name//保存枪的名称
      this.formData.goods_id = row.id
      this.formData.image = row.image
      this.formData.prize_form = this.prizeType
      this.formData.prize_id = row.id
      // this.selectedPrize = JSON.parse(JSON.stringify(row))
      //先置空再赋值
      this.selectedPrize1 = undefined
      this.selectedPrize2 = undefined
      this.selectedPrize3 = undefined
      switch (this.prizeType) {
        case 1:
          //扎比特或ig物品
          this.selectedPrize1 = JSON.parse(JSON.stringify(row)); break;
        case 2:
          //自有物品
          this.selectedPrize2 = JSON.parse(JSON.stringify(row)); break;
        case 3:
          //机器人物品
          this.selectedPrize3 = JSON.parse(JSON.stringify(row)); break;
      }

      //ig或zbt要多传一个字段
      if (this.prizeType == 1) {
        this.formData.market_hash_name = row.market_hash_name;
      } else {
        this.formData.market_hash_name = undefined;
      }

      if (this.prizeType === 1 || this.prizeType === 3) {
        this.formData.appearance = row.appearance
        this.formData.quality = row.quality
        this.formData.type = row.type
        this.formData.classify = row.classify
        this.formData.rarity = row.rarity //dota的稀有度
        if (this.queryPrize.type === 2) {
          //如果选的dota物品
          this.formData.shop_type = 3 //商城类型设为dota
          this.formData.goods_type = 2 //物品类型设为dota
        } else {
          //如果选的csgo物品
          this.formData.goods_type = 1 //物品类型设为csgo
        }
      }

      this.visiblePrize = false//关闭弹窗
    },
    getDotararity(num) {
      //匹配dota的稀有度
      for (let item of this.rarityList) {
        if (item.val === num) {
          return item.text
        }
      }
      return '无'
    }
  },
  created() {
    this.getData()
    this.getPrize()
    this.getZbtPrize()
    this.getRobotPrize()
    this.getDeliveryWay()
    this.getShopEnable()//获取商城开关状态
    this.getShopAffordableEnable()//获取平价商城开关状态
    this.getNightDelivery()//获取夜间发货状态
    this.getRetrieveMark()//获取取回开关状态
    this.getForbidFetch()//获取禁止所有取回开关状态
    this.getActivityShopEnable()//获取活动商城开关状态
    this.getUpdatePrice()//获取快速更新价格开关状态
    this.getRobotStatus()//同步库存链接
  }
}
</script>

<style lang="less">
.table-image {
  max-height: 100px;
  max-width: 100px;
}

.avatar-uploader {
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
  }

  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
  overflow: auto;
  /* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
  display: none;
}

.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;

    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
</style>
